import { Button, Checkbox, FormControlLabel, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import "../App.css";
import axios from "axios";
import SearchIcon from "@mui/icons-material/Search";

function Main() {
  const [name, setName] = useState("charizard");
  const [find, setFind] = useState("charizard");
  const [img, setImg] = useState("");
  const [type, setType] = useState("");
  const [ability, setAbility] = useState("");
  const [abilityTwo, setAbilityTwo] = useState("");
  const [abilityLength, setAbilityLength] = useState("");
  const [species, setSpecies] = useState("");
  const [shiny, setShiny] = useState(false);

  useEffect(() => {
    async function getData() {
      if (find !== "") {
        try {
          let res = await axios.get(`https://pokeapi.co/api/v2/pokemon/${find}`);
          if (shiny) {
            setImg(res.data.sprites.front_shiny);
          } else {
            setImg(res.data.sprites.front_default);
          }
          setType(res.data.types[0].type.name);
          setAbility(res.data.abilities[0].ability.name);
          setAbilityTwo(res.data.abilities[1]?.ability.name || "");
          setAbilityLength(res.data.abilities.length);
          setSpecies(res.data.species.name);
        } catch (error) {
          console.error("Error fetching data: ", error);
        }
      }
    }
    getData();
  }, [find, shiny]);

  useEffect(() => {
    handleSearchSubmit();
  }, []);

  const handleSearchChange = (event) => {
    setName(event.target.value);
  };

  const handleSearchSubmit = () => {
    if (name !== "") setFind(name);
  };

  const handleCheckboxChange = (event) => {
    setShiny(event.target.checked);
  };

  return (
    <div>
      <div className="Row">
        <h1>Search Pokemons!</h1>
        <TextField
          onChange={handleSearchChange}
          value={name}
          id="standard-helperText"
          label="Search Pokemon"
          variant="standard"
        />
        <Button onClick={handleSearchSubmit} startIcon={<SearchIcon />}>
          Search
        </Button>
      </div>
      <div>
        <img src={img} alt="Pokemon" />
        <FormControlLabel
          control={
            <Checkbox
              aria-label="Shiny?"
              checked={shiny}
              onChange={handleCheckboxChange}
            />
          }
          label="Shiny?"
        />
        <h3 className="name">{name.toUpperCase()}</h3>
        <h4>Type</h4>
        <p className="type">{type}</p>
        <h4>Ability</h4>
        <ul
          className="center col abil"
          style={{
            display: "flex",
            flex: "1",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <li className="ability">{ability}</li>
          <li>{abilityTwo}</li>
        </ul>
        <h4>Species</h4>
        <p className="species">{species}</p>
      </div>
    </div>
  );
}

export default Main;
